import { render, staticRenderFns } from "./NotificationContractIcon.vue?vue&type=template&id=63069180&"
import script from "./NotificationContractIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationContractIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports